import { Component } from 'react';
import { Fragment } from 'react';
import Usermgnt from 'Components/Users/Usermgnt';
import Pagination from 'Components/Pagination';
import formUrlParams from 'Helpers/urlform';
import { ConvertToCSV } from 'Helpers/index';
import { CSVLink } from 'react-csv';
import { exportUsersData } from 'Helpers/queries';

export default class Users extends Component{
    
    constructor(props){
        super(props);
        this.state={
            filtered: [],
            responseArray: [],
            pageLimit: 10,
            initialPage: 1,
            activeSort: {},
            inviteUsersArray: [],
            exportUsers: [
                {
                    name: 'Name',
                    email: 'Email',
                    registeredDate: 'Registered Date',
                    deviceType: 'Device Type',
                }
            ],
            exportPage: 1,
            exportSize: 100,
            callExportApi: true,
            exportStatus: 'Export To CSV',
        }
    }
    
    componentDidMount(){
        let browserBackClick = false;
        window.onpopstate = (e)=> {
            const location = e.target.location;
            if(location.pathname === '/User/UserManagement'){
                browserBackClick = true;
            }
        }
        setTimeout(() => {
            if (!browserBackClick) {
                this.props.fetchUsersList();
                this.props.exportUsers();
            }
        }, 50);
        
        this.handleExportStatus()
    }

    exportUsersData = () => {
        const { exportPage, exportSize, exportUsers, exportStatus, currentPage } = this.state;
        if(exportStatus !== 'Export To CSV') return;
        this.props.exportUsersStatus('Users Export Is In Progress...')
        console.log('users data from state',currentPage, exportPage, exportSize, exportUsers);
        return exportUsersData('/users', exportPage, exportSize, exportUsers, 'User Details.csv', this.props.exportUsersStatus, 1, true);
    }

    exportCsv = () => {
        const csvSupportedFormat = ConvertToCSV(JSON.stringify(this.state.exportUsers));
        const csvContent = 'data:text/csv;charset=utf-8,' + csvSupportedFormat;
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement('a');
        link.setAttribute('href', encodedUri);
        link.setAttribute('download', 'User Details.csv');
        document.body.appendChild(link);
        link.click(); 
    }

    componentDidUpdate(prevProps) {
        const { exportUsersId: prevExportUsersId } = prevProps;
        const { exportUsersId } = this.props;
        if(prevExportUsersId !== exportUsersId) {
            this.handleExportStatus()
        }
    }

    handleExportStatus = () => {
        const { exportUsersId, exportStatus } = this.props;
        if(exportUsersId && exportStatus && exportStatus !== 'undefined') {
            this.setState({ exportStatus: exportStatus })
        }
    }

    formUrlParams = ( name, value, rest ) => {
        const { filtered, activeSort } = this.state;
        const filterResponse = formUrlParams(filtered, name, value);
        this.setState({ filtered: filterResponse, ...rest }, () => {
            let updatedFilter = this.state.filtered;
            if(activeSort && activeSort.id){
                updatedFilter = [
                    ...this.state.filtered,
                    activeSort
                ]
            }
            this.props.fetchUsersList(updatedFilter);
            this.props.exportUsers(updatedFilter);
        });
    }
  
    /**
     * @method formUrlSort
     * @summary Construct the query string based on user selection
     * @return {function} call fetch admin user api after change local state
     */
    formUrlSort = (activeSort) => {
        this.setState({
            activeSort: activeSort,
        }, () => {
            const updatedFilter = [
                ...this.state.filtered,
                this.state.activeSort
            ]
            this.props.fetchUsersList(updatedFilter);
            this.props.exportUsers(updatedFilter);
        })
    }
    
    createDevice = () => {
        const deviceArray = [ 'Android', 'iOS', 'Web' ]
        return deviceArray.map((type, index) => {
            return (
                <option key={ index } value={ type.toLowerCase() }>{type}</option>
            )
        })
    }
    
    createStatus = () => {
        const statusArray = [ 'In Active', 'Active' ]
        return statusArray.map((status, index) => {
            return (
                <option key={ index } value={ index }>{status}</option>
            )
        })
    }
    
    createType = () => {
        const typeArray = [ 'General', 'SSO User' ]
        return typeArray.map((type, index) => {
            return (
                <option key={ index } value={ index }>{type}</option>
            )
        })
    }

    setPageLimit = ( name, value ) => {
      this.formUrlParams(name, value,{ pageLimit: value })
    }

    handleInviteUsers = (users) => {
        this.setState({ inviteUsersArray: users })
    }

    handleInviteAll = () => {
        const { inviteUsersArray } = this.state;
        if(inviteUsersArray.length > 0) {
            this.props.sendInvite(inviteUsersArray);
        }
    }

    render(){
      const { usersList, totalRecords, currentPage, loading } = this.props
      const { activeSort, exportUsers, exportStatus } = this.state;
        return(
            <Fragment>
                <div className='grid pageContainer_inner'>
                    <div className='heading-block gap-10'>
                        <div className='block_flex'>
                            <h4>Users</h4>
                        </div>
                        <div className='block_flex'>
                            { this.props?.exportUsersData?.length && <CSVLink
                                data = { this.props.exportUsersData }
                                filename = { 'User Details.csv' }
                                className = 'btn btn_green'
                                onClick={ () => {
                                  console.log('Export Data'); // Your click handling logic
                                } }
                              >
                                { exportStatus }
                            </CSVLink>}
                        </div>
                        </div>
                    <div className='groupinfo' />
                        <Usermgnt
                        usersList={ usersList }
                        totalRecords= { totalRecords }
                        currentPage={  currentPage }
                        loading={ loading }
                        formUrl= { this.formUrlParams }
                        device = { this.createDevice }
                        status = { this.createStatus }
                        type = { this.createType }
                        formUrlSort = { this.formUrlSort }
                        activeSort = { activeSort }
                        pagination={ <Pagination
                                handleClick={ this.formUrlParams }
                                totalRecords={ totalRecords }
                                currentPage={ this.state.initialPage }
                                setPageLimit={ this.setPageLimit }
                                initialPage={ currentPage }
                                pageLimit={ this.state.pageLimit }
                            />
                        }
                        />
                </div>
            </Fragment>
        )
    }
}